//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, ViewChild } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';

export interface IExportD3eKeysDialogResult {
  password: string;
}

@Component({
    selector: 'app-export-d3e-keys-dialog',
    templateUrl: './export-d3e-keys-dialog.component.html',
    styleUrls: ['./export-d3e-keys-dialog.component.scss'],
    standalone: false
})
export class ExportD3eKeysDialogComponent {
  @ViewChild('tooltipNew') tooltipNew: MatTooltip;
  @ViewChild('tooltipConfirm') tooltipConfirm: MatTooltip;
  password = '';
  confirm = '';
  encrypt = true;
  capsOnNew: boolean = false;
  capsOnConfirm: boolean = false;
  passwordInputIsFocused: boolean;
  passwordConfirmInputIsFocused: boolean;

  constructor(private readonly dialogRef: MatDialogRef<ExportD3eKeysDialogComponent, IExportD3eKeysDialogResult>) { }

  onClickOK() {
    const result: IExportD3eKeysDialogResult = {
      password: this.password,
    }
    this.dialogRef.close(result);
  }

  onClickCancel() {
    this.dialogRef.close();
  }

  get disableOKButton(): boolean {
    if (this.encrypt) {
      if (this.password.length < 3) {
        return true;
      }
      return this.password != this.confirm;
    }
    return false;
  }

  onCapsLockNewChanged(event: boolean) {
    this.capsOnNew = event && this.passwordInputIsFocused;
  }

  onCapsLockConfirmChanged(event: boolean) {
    this.capsOnConfirm = event && this.passwordConfirmInputIsFocused;
  }

  passwordFocus(id: string) {
    this.passwordInputIsFocused = false;
    this.passwordConfirmInputIsFocused = false;
    switch (id) {
      case "newPassInput":
        this.passwordInputIsFocused = true;
        break;
      case "confirmPassInput":
        this.passwordConfirmInputIsFocused = true;
        break;
    }
  }

  passwordBlur() {
    this.passwordInputIsFocused = false;
    this.passwordConfirmInputIsFocused = false;
  }
}
